"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Package, Shield, Truck } from "lucide-react";
export default function ProductsServicesPreview() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const services = [{
    icon: Package,
    title: "Global Sourcing",
    description: "Access to verified suppliers across Middle East, Africa, Asia, and Europe for premium commodities."
  }, {
    icon: Shield,
    title: "Quality Assurance",
    description: "Rigorous inspection protocols and comprehensive documentation for every shipment."
  }, {
    icon: Truck,
    title: "Logistics Coordination",
    description: "End-to-end freight management with flexible Incoterms and timely delivery."
  }];
  return <section id="products-services-preview" ref={sectionRef} className="dark bg-background text-foreground py-24 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className={`
                  bg-primary border-border hover:shadow-strong
                  transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]
                  hover:-translate-y-1.5 group
                  ${isVisible ? "animate-fade-in-up" : "opacity-0"}
                `} style={{
            animationDelay: isVisible ? `${i * 100}ms` : "0ms"
          }}>
                <CardHeader className="space-y-4">
                  <div className="flex justify-center">
                    <Icon className="w-12 h-12 text-accent transition-transform duration-[var(--duration-medium)] group-hover:rotate-12" strokeWidth={1} />
                  </div>
                  <CardTitle className="text-xl text-center text-white">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-center text-muted-foreground leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}